import * as RawModel from '@/common/api/api-raw-types';
import {AbstractResourceBuilder} from 'vue3-starter/src/typescript/resource/AbstractResourceBuilder';
import BriefCurrencyResource from '@/brief-hub/brief/BriefCurrencyResource';

class BriefCurrencyResourceBuilder extends AbstractResourceBuilder<BriefCurrencyResource, RawModel.BriefCurrencyResource> {
    protected _buildResource(data: RawModel.BriefCurrencyResource): BriefCurrencyResource {
        return new BriefCurrencyResource({
            links: this.links,
            currencyCode: data.currency,
        });
    }
}
export const briefCurrencyResourceBuilder = new BriefCurrencyResourceBuilder();
